import { render, staticRenderFns } from "./ShopService.vue?vue&type=template&id=b20d5418&scoped=true"
import script from "./ShopService.vue?vue&type=script&lang=js"
export * from "./ShopService.vue?vue&type=script&lang=js"
import style0 from "./ShopService.vue?vue&type=style&index=0&id=b20d5418&prod&lang=scss&scoped=true"
import style1 from "./ShopService.vue?vue&type=style&index=1&id=b20d5418&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20d5418",
  null
  
)

export default component.exports